import { render, staticRenderFns } from "./LmCapturePhoto.vue?vue&type=template&id=1644855f&scoped=true&"
import script from "./LmCapturePhoto.vue?vue&type=script&lang=js&"
export * from "./LmCapturePhoto.vue?vue&type=script&lang=js&"
import style0 from "./LmCapturePhoto.vue?vue&type=style&index=0&id=1644855f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1644855f",
  null
  
)

export default component.exports